import { render, staticRenderFns } from "./UserStatusSetup.vue?vue&type=template&id=90ece640&scoped=true&"
import script from "./UserStatusSetup.vue?vue&type=script&lang=ts&"
export * from "./UserStatusSetup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ece640",
  null
  
)

export default component.exports